import React from 'react';
import Question from './Question';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'question';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <Question
        key={`${type}-${index}`}
        question={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
